[
  {
    "code": "RU-AD",
    "name": "Adygea"
  },
  {
    "code": "RU-ALT",
    "name": "Altai Krai"
  },
  {
    "code": "RU-AL",
    "name": "Altai Republic"
  },
  {
    "code": "RU-AMU",
    "name": "Amur Oblast"
  },
  {
    "code": "RU-ARK",
    "name": "Arkhangelsk Oblast"
  },
  {
    "code": "RU-AST",
    "name": "Astrakhan Oblast"
  },
  {
    "code": "RU-BA",
    "name": "Bashkortostan"
  },
  {
    "code": "RU-BEL",
    "name": "Belgorod Oblast"
  },
  {
    "code": "RU-BRY",
    "name": "Bryansk Oblast"
  },
  {
    "code": "RU-BU",
    "name": "Buryatia"
  },
  {
    "code": "RU-CE",
    "name": "Chechnya"
  },
  {
    "code": "RU-CHE",
    "name": "Chelyabinsk Oblast"
  },
  {
    "code": "RU-CHU",
    "name": "Chukotka Autonomous Okrug"
  },
  {
    "code": "RU-CU",
    "name": "Chuvashia"
  },
  {
    "code": "RU-DA",
    "name": "Dagestan"
  },
  {
    "code": "RU-IN",
    "name": "Ingushetia"
  },
  {
    "code": "RU-IRK",
    "name": "Irkutsk Oblast"
  },
  {
    "code": "RU-IVA",
    "name": "Ivanovo Oblast"
  },
  {
    "code": "RU-YEV",
    "name": "Jewish Autonomous Oblast"
  },
  {
    "code": "RU-KB",
    "name": "Kabardino-Balkaria"
  },
  {
    "code": "RU-KGD",
    "name": "Kaliningrad Oblast"
  },
  {
    "code": "RU-KL",
    "name": "Kalmykia"
  },
  {
    "code": "RU-KLU",
    "name": "Kaluga Oblast"
  },
  {
    "code": "RU-KAM",
    "name": "Kamchatka Krai"
  },
  {
    "code": "RU-KC",
    "name": "Karachay-Cherkessia"
  },
  {
    "code": "RU-KEM",
    "name": "Kemerovo Oblast"
  },
  {
    "code": "RU-KHA",
    "name": "Khabarovsk Krai"
  },
  {
    "code": "RU-KK",
    "name": "Khakassia"
  },
  {
    "code": "RU-KHM",
    "name": "Khanty-Mansi Autonomous Okrug"
  },
  {
    "code": "RU-KIR",
    "name": "Kirov Oblast"
  },
  {
    "code": "RU-KO",
    "name": "Komi"
  },
  {
    "code": "RU-KOS",
    "name": "Kostroma Oblast"
  },
  {
    "code": "RU-KDA",
    "name": "Krasnodar Krai"
  },
  {
    "code": "RU-KYA",
    "name": "Krasnoyarsk Krai"
  },
  {
    "code": "RU-KGN",
    "name": "Kurgan Oblast"
  },
  {
    "code": "RU-KRS",
    "name": "Kursk Oblast"
  },
  {
    "code": "RU-LEN",
    "name": "Leningrad Oblast"
  },
  {
    "code": "RU-LIP",
    "name": "Lipetsk Oblast"
  },
  {
    "code": "RU-MAG",
    "name": "Magadan Oblast"
  },
  {
    "code": "RU-ME",
    "name": "Mari El"
  },
  {
    "code": "RU-MO",
    "name": "Mordovia"
  },
  {
    "code": "RU-MOW",
    "name": "Moscow"
  },
  {
    "code": "RU-MOS",
    "name": "Moscow Oblast"
  },
  {
    "code": "RU-MUR",
    "name": "Murmansk Oblast"
  },
  {
    "code": "RU-NEN",
    "name": "Nenets Autonomous Okrug"
  },
  {
    "code": "RU-NIZ",
    "name": "Nizhny Novgorod Oblast"
  },
  {
    "code": "RU-SE",
    "name": "North Ossetia-Alania"
  },
  {
    "code": "RU-NGR",
    "name": "Novgorod Oblast"
  },
  {
    "code": "RU-NVS",
    "name": "Novosibirsk Oblast"
  },
  {
    "code": "RU-OMS",
    "name": "Omsk Oblast"
  },
  {
    "code": "RU-ORE",
    "name": "Orenburg Oblast"
  },
  {
    "code": "RU-ORL",
    "name": "Oryol Oblast"
  },
  {
    "code": "RU-PNZ",
    "name": "Penza Oblast"
  },
  {
    "code": "RU-PER",
    "name": "Perm Krai"
  },
  {
    "code": "RU-PRI",
    "name": "Primorsky Krai"
  },
  {
    "code": "RU-PSK",
    "name": "Pskov Oblast"
  },
  {
    "code": "RU-KR",
    "name": "Republic of Karelia"
  },
  {
    "code": "RU-ROS",
    "name": "Rostov Oblast"
  },
  {
    "code": "RU-RYA",
    "name": "Ryazan Oblast"
  },
  {
    "code": "RU-SPE",
    "name": "Saint Petersburg"
  },
  {
    "code": "RU-SA",
    "name": "Sakha"
  },
  {
    "code": "RU-SAK",
    "name": "Sakhalin Oblast"
  },
  {
    "code": "RU-SAM",
    "name": "Samara Oblast"
  },
  {
    "code": "RU-SAR",
    "name": "Saratov Oblast"
  },
  {
    "code": "RU-SMO",
    "name": "Smolensk Oblast"
  },
  {
    "code": "RU-STA",
    "name": "Stavropol Krai"
  },
  {
    "code": "RU-SVE",
    "name": "Sverdlovsk Oblast"
  },
  {
    "code": "RU-TAM",
    "name": "Tambov Oblast"
  },
  {
    "code": "RU-TA",
    "name": "Tatarstan"
  },
  {
    "code": "RU-TOM",
    "name": "Tomsk Oblast"
  },
  {
    "code": "RU-TUL",
    "name": "Tula Oblast"
  },
  {
    "code": "RU-TY",
    "name": "Tuva"
  },
  {
    "code": "RU-TVE",
    "name": "Tver Oblast"
  },
  {
    "code": "RU-TYU",
    "name": "Tyumen Oblast"
  },
  {
    "code": "RU-UD",
    "name": "Udmurtia"
  },
  {
    "code": "RU-ULY",
    "name": "Ulyanovsk Oblast"
  },
  {
    "code": "RU-VLA",
    "name": "Vladimir Oblast"
  },
  {
    "code": "RU-VGG",
    "name": "Volgograd Oblast"
  },
  {
    "code": "RU-VLG",
    "name": "Vologda Oblast"
  },
  {
    "code": "RU-VOR",
    "name": "Voronezh Oblast"
  },
  {
    "code": "RU-YAN",
    "name": "Yamalo-Nenets Autonomous Okrug"
  },
  {
    "code": "RU-YAR",
    "name": "Yaroslavl Oblast"
  },
  {
    "code": "RU-CHI",
    "name": "Zabaykalsky Krai"
  }
]